const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/tweetOptTrack',
    name: 'TweetOptTrack',
    component: layout,
    redirect: '/tweetOptTrack/index',
    hiddenInMenu: true, // 暂时隐藏
    meta: {
      title: '推文优化追踪',
      icon: 'i-menu:tweet',
      i18Key: 'router.user.tweetOptTrack.title',
      roles: [1]
    },
    sort: 31,
    children: [
      {
        path: 'index',
        name: 'TweetOptTrackIndex',
        component: () => import('@/views/TweetOptTrack/Index.vue'),
        meta: {
          title: '推文优化追踪',
          icon: 'i-menu:tweet',
          i18Key: 'router.user.tweetOptTrack.index',
          roles: [1],
          headerConditions: ['brand', 'timeBtn', 'questionBtn']
        }
      }
    ]
  }
]
export default routes
